import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    message: null,
    description: null,
    type: "info", // 'success', 'error', 'warning', etc.
    placement: "topRight", // default placement
    duration: 4.5, // default duration
    style: {}, // custom styles
  },
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload.message;
      state.description = action.payload.description;
      state.type = action.payload.type || "info";
      state.placement = action.payload.placement || "topRight";
      state.duration = action.payload.duration || 4.5;
      state.style = action.payload.style || {};
    },
    clearNotification: (state) => {
      state.message = null;
      state.description = null;
      state.type = "info";
      state.placement = "topRight";
      state.duration = 4.5;
      state.style = {};
    },
  },
});

export const { showNotification, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
